import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { StyleSheet, css } from '@coursera/coursera-ui';

import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCardBody from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardBody';
import { TabCaption } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/typography';

import _t from 'i18n!nls/program-skills-objectives';

type HowToCustomizeCourseRecommendationsInformationCard = InformationCardProps;

//
// this is like a tab card but with only one tab which the tab list layout
// doesn't support. FWIW, if we need this kind of card more, we should add a
// case to the TabListInformationCard for where there is only one tab child.
//
const styles = StyleSheet.create({
  root: {
    padding: '24px 14px',
  },

  section: {
    width: '50%',
  },
});

const HowToCustomizeCourseRecommendationsInformationCard: React.FC<
  HowToCustomizeCourseRecommendationsInformationCard
> = (props) => (
  <InformationCard {...props} rootClassName={css(styles.root, props.rootClassName).className}>
    <InformationCardBody>
      <section {...css(styles.section)}>
        <TabCaption>{_t('How to customize course recommendations')}</TabCaption>
        <Typography2 component="p" variant="bodyPrimary">
          {_t(
            'The ability to customize course recommendations is not available to Admins at this time. Please contact your Customer Success Manager to customize the course recommendations for this SkillSet.'
          )}
        </Typography2>
      </section>
    </InformationCardBody>
  </InformationCard>
);

export default HowToCustomizeCourseRecommendationsInformationCard;
